import { useInView as useInViewLib } from 'react-intersection-observer';

export const useInView = useInViewLib;
